//#region Styles
import {
    Container } from "./styles";
//#endregion
//#region Images
import CrossIcon from "icons/CrossIcon";
//#endregion

const CloseButton = ({
    color = "var(--red-1)", 
    ...restProps 
}) => {
    return (
        <Container
            {...restProps}>
            <CrossIcon color={color}/>
        </Container>
    );
}

export default CloseButton;